import { Link, useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import swal from "sweetalert2";
import Loading from "./Loading";
import { useState } from "react";

function Card({ property, logged }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const editData = async () => {
    navigate(`/edit/${property._id}`);
  };

  const hapus = async () => {
    const response = await fetch(
      `https://kjpp-server.vercel.app/api/properties/delete/${property._id}`,
      {
        method: "DELETE",
      }
    );
    if (response.ok) {
      swal
        .fire({
          title: "Delete Success!",
          icon: "success",
          confirmButtonText: "Close",
          timer: 1000,
        })
        .then(() => {
          window.location.reload(true);
        });
    }
  };

  const deleteData = () => {
    swal
      .fire({
        title: "Are you sure?",
        showDenyButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "No",
        customClass: {
          actions: "delete data",
          denyButton: "order-1",
          confirmButton: "order-2",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          hapus();
        } else {
          swal.fire("Cancelled", "Data tidak jadi dihapus :)");
        }
      });
  };
  return (
    <div className="w-full min-w-80 max-w-sm min-h-64 mx-auto hover:scale-[1.02] transition duration-200 bg-white border border-gray-200 rounded-lg shadow">
      {loading && (
        <div className="h-full w-full flex justify-center items-center">
          <Loading />
        </div>
      )}
      {!loading && (
        <div>
          <Link to={`/detail/${property._id}`}>
            <img
              src={property.foto[0].secure_url}
              alt="image"
              className="w-full max-h-40 object-cover"
            />
          </Link>
          <div className="p-4">
            <div className="flex justify-between items-center mb-1">
              <Link to={`/detail/${property._id}`}>
                <h5 className="text-xl underline font-bold tracking-tight text-gray-900">
                  {property.harga.toLocaleString("id-ID", {
                    style: "currency",
                    currency: "IDR",
                  })}
                </h5>
              </Link>
              {logged && (
                <div className="flex">
                  <IconButton onClick={editData}>
                    <Edit />
                  </IconButton>
                  <IconButton onClick={deleteData}>
                    <Delete />
                  </IconButton>
                </div>
              )}
            </div>
            <p className="mb-1 capitalize text-sm md:text-base font-normal text-gray-700">
              {property.wilayah}, {property.alamat}
            </p>
            <p className="mb-2 capitalize text-sm font-normal text-gray-700">
              {property.tipe}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default function WholeCard({ properties, logged }) {
  return (
    <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl xxl:grid-cols-4">
      {properties &&
        properties.map((property) => (
          <Card key={property._id} property={property} logged={logged} />
        ))}
    </div>
  );
}
